import { getAvailableEvoInstances, getCurrentEvoInstance, } from '../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { getSelectedInstanceState } from '../../store/sessionStorageHelpers/selectedInstanceHelper';
export function instances(data) {
    if (!data) {
        return [];
    }
    return data.servers
        .map((e) => ({ key: e.instanceUUID, label: e.displayName }))
        .sort();
}
export function optionGroups(data) {
    if (!data) {
        return [];
    }
    const response = [];
    data.servers
        .map((e) => e.organizationName)
        .reduce((previousValue, currentValue) => {
        if (previousValue.indexOf(currentValue) === -1) {
            previousValue.push(currentValue);
        }
        return previousValue;
    }, [])
        .sort((a, b) => (a.toLocaleLowerCase() < b.toLocaleLowerCase() ? -1 : 0))
        .forEach((org) => {
        const instanceList = data.servers
            .filter((e) => e.organizationName === org)
            .sort((a, b) => (a.host > b.host ? 1 : -1))
            .map((e) => `${e.instanceUUID}`);
        response.push({ label: org, optionIds: instanceList });
    });
    return response;
}
export function getPreviousOrDefaultInstance(data) {
    if (!data || data.servers.length === 0) {
        return '';
    }
    const filteredInstances = data.servers.find((server) => server.host === getSelectedInstanceState());
    if (filteredInstances) {
        const { instanceUUID } = filteredInstances;
        return instanceUUID;
    }
    return optionGroups(data)[0].optionIds[0];
}
export function getPreviousOrDefaultOrg() {
    const previousInstance = getCurrentEvoInstance();
    if (previousInstance && previousInstance.org) {
        return previousInstance.org.id;
    }
    const allEvo = getAvailableEvoInstances();
    if (!allEvo || allEvo.length === 0) {
        return '';
    }
    return allEvo[0].org.id;
}
export const getEvoInstanceForOrgIdWithOptionalHubCode = (orgId, evoData, hubCode) => {
    if (!evoData) {
        return null;
    }
    const org = evoData === null || evoData === void 0 ? void 0 : evoData.organizations.find((o) => o.id === orgId);
    const serviceAccess = hubCode
        ? evoData === null || evoData === void 0 ? void 0 : evoData.service_access.find((o) => o.org_id === orgId && o.hub_code === hubCode)
        : evoData === null || evoData === void 0 ? void 0 : evoData.service_access.find((o) => o.org_id === orgId);
    const hub = evoData === null || evoData === void 0 ? void 0 : evoData.hubs.find((h) => h.code === (serviceAccess === null || serviceAccess === void 0 ? void 0 : serviceAccess.hub_code));
    if (!hub || !org) {
        return null;
    }
    return { org, hub };
};
//# sourceMappingURL=utils.js.map